import { render, staticRenderFns } from "./StartTask.vue?vue&type=template&id=021f83d4&scoped=true&"
import script from "./StartTask.vue?vue&type=script&lang=js&"
export * from "./StartTask.vue?vue&type=script&lang=js&"
import style0 from "./StartTask.vue?vue&type=style&index=0&id=021f83d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021f83d4",
  null
  
)

export default component.exports